import { Card, CardContent } from "@/components/ui/card";
import { FeedItem } from "@/types/feed";
import MTGLayout from "@/components/cards/templates/MTGLayout";
import { SharedCardFooter } from "./shared/CardFooter";

interface FeedLayoutProps {
  post: FeedItem;
}

export function FantasyFeedLayout({ post }: FeedLayoutProps) {
  console.log('Feed post creator:', post.creator);
  
  // Parse metadata if it's a string
  const metadata = typeof post.metadata === 'string' ? 
    JSON.parse(post.metadata) : post.metadata;
  
  const cardData = {
    title: post.title,
    description: post.description,
    imageUrl: post.imageUrl ? 
      (post.imageUrl.startsWith('http') ? post.imageUrl : `${import.meta.env.VITE_API_URL}${post.imageUrl}`)
      : undefined,
    cardClass: metadata?.cardClass,
    flavorText: metadata?.flavorText,
    manaCost: metadata?.manaCost,
    rarity: metadata?.rarity,
    power: metadata?.power,
    toughness: metadata?.toughness,
    metadata: {
      ...metadata,
      type: metadata?.cardType || metadata?.type, // Pass both type fields
      language: metadata?.language || 'en',
      playerName: post.creator?.username || 'Anonymous' // Use creator's username
    }
  };

  return (
    <Card className="mb-4 max-w-xl bg-black p-2">
      <CardContent className="flex flex-col items-center p-0">
        <div className="w-full flex justify-center mb-4">
          <MTGLayout cardData={cardData} />
        </div>
      </CardContent>
      
      <SharedCardFooter 
        playerName={post.creator?.username}
      />
    </Card>
  );
}